// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { InternalFlashbar } from './internal';
export default function Flashbar(props) {
    var _a, _b, _c, _d;
    const { __internalRootRef } = useBaseComponent('Flashbar', {
        props: { stackItems: props.stackItems },
        metadata: {
            itemsWithPersistence: (_b = (_a = props.items) === null || _a === void 0 ? void 0 : _a.filter(item => { var _a; return !!((_a = item.persistenceConfig) === null || _a === void 0 ? void 0 : _a.uniqueKey); }).length) !== null && _b !== void 0 ? _b : null,
            itemsWithCrossServicePersistence: (_d = (_c = props.items) === null || _c === void 0 ? void 0 : _c.filter(item => { var _a; return !!((_a = item.persistenceConfig) === null || _a === void 0 ? void 0 : _a.crossServicePersistence); }).length) !== null && _d !== void 0 ? _d : null,
        },
    });
    return React.createElement(InternalFlashbar, { __internalRootRef: __internalRootRef, ...props });
}
applyDisplayName(Flashbar, 'Flashbar');
//# sourceMappingURL=index.js.map